import { createTheme } from "@mui/material";

export const productFormTheme = createTheme({
    palette: {
        mode: "light",
        primary: { main: "#0B6EFB" },
        background: { default: "#f4f7fc", paper: "#fff" },
    },
    shape: { borderRadius: 12 },
    typography: {
        fontFamily: 'Inter, Roboto, "Helvetica Neue", Arial, sans-serif',
    },
});
